import React, { Fragment } from "react";
import "./hamberger-menu.css";
const HambergerMenu = () => {
  return (
    <Fragment>
      <nav role="navigation">
        <div id="menuToggle">
          <input type="checkbox" />

          <span></span>
          <span></span>
          <span></span>

          <ul id="menu">
            <a href="#">
              <li>صفحه اصلی</li>
            </a>
            <a href="#">
              <li>فروشگاه</li>
            </a>
            <a href="#">
              <li>تماس با ما</li>
            </a>
            <a href="#">
              <li>درباره ما</li>
            </a>
          </ul>
        </div>
      </nav>
    </Fragment>
  );
};

export default HambergerMenu;
